package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import meineglasfaser.frontend.common.BackendApi
import org.jetbrains.compose.web.dom.Progress

@Composable
fun GlobalBusyIndicator() {
    val numActiveRequests by BackendApi.numActiveRequests.collectAsState()

    Progress(
        attrs = {
            classes("global-busy-indicator")
            if (numActiveRequests > 0) {
                classes("active")
            }
        }
    )
}
